import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { useTrackPageView } from './usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withTrackPageView(WrappedComponent) {
  const componentName = getComponentName(WrappedComponent);
  const TrackPageViewDecorator = props => {
    const _trackPageView = useTrackPageView();
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      trackPageView: _trackPageView
    }, props));
  };
  TrackPageViewDecorator.displayName = `PageViewTrackingWithContext(${componentName})`;

  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  TrackPageViewDecorator.defaultProps = WrappedComponent.defaultProps;
  attachWrappedComponent(TrackPageViewDecorator, WrappedComponent);
  return TrackPageViewDecorator;
}